import { create } from 'zustand';

// Sort options surfaced in the toolbar dropdown.
export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'name', label: 'Name (A–Z)' },
  { value: 'downloads', label: 'Most downloads' },
  { value: 'versions', label: 'Most versions' },
];

const initialState = {
  searchTerm: '',
  activeTypes: [], // [] = all; otherwise subset of 'classification' | 'bounding_box' | 'segmentation'
  sortBy: 'newest',
  ownerFilter: '', // '' = all owners; otherwise an owner_id
  selectedModel: null, // model object shown in the detail drawer
};

const useModelHubStore = create((set) => ({
  ...initialState,

  setSearchTerm: (value) => set({ searchTerm: value ?? '' }),
  setSortBy: (value) => set({ sortBy: value || 'newest' }),
  setOwnerFilter: (value) => set({ ownerFilter: value || '' }),
  setSelectedModel: (value) => set({ selectedModel: value || null }),

  setActiveTypes: (value) => set({ activeTypes: Array.isArray(value) ? value : [] }),

  toggleType: (type) =>
    set((state) => ({
      activeTypes: state.activeTypes.includes(type)
        ? state.activeTypes.filter((t) => t !== type)
        : [...state.activeTypes, type],
    })),

  clearFilters: () => set({ searchTerm: '', activeTypes: [], ownerFilter: '' }),
  resetAll: () => set({ ...initialState }),
}));

export default useModelHubStore;
